import { SearchableSelectType } from 'components/inputs/searchableSelect';

import { EntityPermissionUsers } from 'models/user.model';

export enum UserGroup {
    editors = 'editors',
    managers = 'managers',
    admins = 'admins',
}
export type Groups = {
    [K in keyof typeof UserGroup]: EntityPermissionUsers[];
};
export interface EntityPermissionUserFormikContext {
    groups: Groups;
    selectedEditors: SearchableSelectType[];
    selectedGroup?: keyof typeof UserGroup;
}
